'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.Modal = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _listeners = require('../../utils/listeners');

var _tracking = require('../../utils/tracking');

var _functional = require('../../utils/functional');

var _images = require('../../utils/images');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var classes = {
  MODAL_ACTIVE: 'mod-Modal-active'
};

var selectors = {
  OPEN_BUTTON: '.js-Modal_OpenButton',
  CLOSE_BUTTON: '.js-Modal_CloseButton',
  LAZYLOAD_IMAGE: '.lazyload-modal'
};

var tracking = {
  ACTION_OPEN_MODAL: 'Open Modal',
  ACTION_CLOSE_MODAL: 'Close Modal'
};

var defaultConfig = {
  trackingCategory: 'Modal'
};

var Modal = exports.Modal = function () {
  function Modal(el, config) {
    (0, _classCallCheck3.default)(this, Modal);

    this.el = el;

    this.config = (0, _assign2.default)({}, defaultConfig, config, this.getConfig());

    this.els = this.getEls();

    this.imagesLoaded = false;

    this.imagesLoaded = false;

    this.init();
  }

  (0, _createClass3.default)(Modal, [{
    key: 'init',
    value: function init() {
      this.setupListeners();
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.listeners = new _listeners.Listeners();

      this.els.openButtons.forEach(function (button) {
        _this.listeners.add(button, 'click', _this.onOpen.bind(_this));
      });

      this.els.closeButtons.forEach(function (button) {
        _this.listeners.add(button, 'click', _this.onClose.bind(_this));
      });
    }
  }, {
    key: 'onOpen',
    value: function onOpen() {
      this.el.classList.add(classes.MODAL_ACTIVE);

      (0, _functional.lockScroll)(true);
      this.loadImages();

      (0, _tracking.trackGtag)({
        eventCategory: this.config.trackingCategory,
        eventAction: tracking.ACTION_OPEN_MODAL,
        eventLabel: this.config.trackingEventLabel
      });
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.el.classList.remove(classes.MODAL_ACTIVE);

      (0, _functional.lockScroll)(false);

      (0, _tracking.trackGtag)({
        eventCategory: this.config.trackingCategory,
        eventAction: tracking.ACTION_CLOSE_MODAL,
        eventLabel: this.config.trackingEventLabel
      });
    }
  }, {
    key: 'loadImages',
    value: function loadImages() {
      if (this.imagesLoaded) return false;

      this.els.images.forEach(function (image) {
        return (0, _images.loadImage)(image, { loadingClass: classes.LAZYLOAD_IMAGE });
      });

      this.imagesLoaded = true;
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      return {
        modalName: this.el.dataset.modalName,
        trackingCategory: this.el.dataset.trackingCategory,
        trackingEventLabel: this.el.dataset.trackingEventLabel
      };
    }
  }, {
    key: 'getEls',
    value: function getEls() {
      var context = this.el;

      return {
        openButtons: (0, _functional.getElements)(selectors.OPEN_BUTTON + '_' + this.config.modalName),
        closeButtons: (0, _functional.getElements)(selectors.CLOSE_BUTTON, { context: context }),
        images: (0, _functional.getElements)(selectors.LAZYLOAD_IMAGE, { context: context })
      };
    }
  }]);
  return Modal;
}();

var init = exports.init = function init(_ref) {
  var el = _ref.el;

  return new Modal(el);
};